//LOCALES
export const LOCALE_ES = 'es-ES';
export const LOCALE_CA = 'ca-ES';
export const LOCALE_DE = 'de-DE';

//LANGUAGE
export const LANG_ES = 'es';

//DATE FORMATS
export const DATE_FORMAT_MMMM_YYYY = 'MMMM-YYYY';
export const DATE_FORMAT_DDMMYYYY = 'DDMMYYYY';

//PATERNS

export const REGEX_FORMAT_NUMBER = '^([0-9]{1,3}(.[0-9]{3})*|([0-9]+))(,[0-9]{2})';
export const REGEX_WITHOUT_DOT = '^\\s\\s[0-9]+([,][0-9]+)?$';
export const REGEX_NUMBER_WITHOUT_HUNDREDS = '^[0-9]+([,]*[0-9]+)?';
export const REGEX_CHECK_DNI = /^(\d{8})([A-Z])$/;
export const REGEX_CHECK_NIE = /^([X-Z]){1}((\d){7})([A-Z]{1})$/;
export const REGEX_CHECK_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
export const REGEX_VALID_DATE = /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$|^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
export const REGEX_ANY_LETTER = /[a-zA-Z]/;
//NODES
export const NODE_20 = '20';
export const NODE_21 = '21';
